export default __webpack_public_path__ + "static/morrow-bank-small-152fe1eda92771761c59db24237cb8ca.png";